import { types } from '@redux/actions/auth';
import { types as bankTypes } from '@redux/actions/bank';

const initialState = {
  bankIdType: '',
  bankIdLoading: false,
  qrCode: '',
  message: '',
  timeout: null,
};

// Reducer
export default (state = initialState, action) => {
  switch (action.type) {
    case types.SELECT_BANK_ID_TYPE: {
      return {
        ...state,
        bankIdType: action.payload.bankIdType,
      };
    }
    case types.BANK_ID_REQUEST: {
      return {
        ...state,
        bankIdLoading: true,
      };
    }
    case types.STORE_BANK_ID_INSTRUCTIONS:
      return {
        ...state,
        qrCode: action.payload.qrCode,
        message: action.payload.message,
      };
    case types.BANK_ID_SUCCESS:
    case types.BANK_ID_FAILURE:
      return initialState;
    case bankTypes.BANK_LOGIN_SESSION_RESET:
      return {
        ...state,
        bankIdType: initialState.bankIdType,
      };
    case types.SET_BANK_ID_TIMEOUT:
      return {
        ...state,
        timeout: action.payload.endTime,
      };
    default: {
      return state;
    }
  }
};
